// Mock data for Studio Ballet Izora

export const schoolInfo = {
  name: "Studio Ballet Izora",
  taglineEn: "Classical Ballet for Little Dancers",
  taglineId: "Balet Klasik untuk Penari Kecil",
  descriptionEn: "Professional ballet training for children aged 2-10 years in Surabaya. Led by certified instructor Ditamaya with years of experience teaching over 100 children.",
  descriptionId: "Pelatihan balet profesional untuk anak usia 2-10 tahun di Surabaya. Dibimbing oleh instruktur bersertifikat Ditamaya dengan pengalaman bertahun-tahun mengajar lebih dari 100 anak.",
  location: "Surabaya, Indonesia",
  ageRange: "2-10",
  studentsCount: "100+",
  yearsExperience: "5+",
  instagram: "https://www.instagram.com/studioballetizora",
  logoUrl: "/images/logo.jpg"
};

export const instructor = {
  name: "Ditamaya",
  titleEn: "Certified Ballet Instructor",
  titleId: "Instruktur Balet Bersertifikat",
  bioEn: "Ditamaya is a certified professional ballet instructor with years of experience in classical ballet education. She has successfully trained over 100 children in Surabaya and surrounding areas, nurturing young talents with patience and dedication.",
  bioId: "Ditamaya adalah instruktur balet profesional bersertifikat dengan pengalaman bertahun-tahun dalam pendidikan balet klasik. Beliau telah berhasil melatih lebih dari 100 anak di Surabaya dan sekitarnya, membina bakat-bakat muda dengan kesabaran dan dedikasi."
};

export const classes = [
  {
    id: 1,
    titleEn: "Pre-School",
    titleId: "Pra-Sekolah",
    ageRange: "2-4",
    descriptionEn: "Introduction to ballet for our youngest dancers. Focus on basic movements, musicality, and creative expression through play.",
    descriptionId: "Pengenalan balet untuk penari termuda kami. Fokus pada gerakan dasar, musikalitas, dan ekspresi kreatif melalui permainan.",
    image: "/images/preschool.jpeg"
  },
  {
    id: 2,
    titleEn: "Pre-Primary & Primary",
    titleId: "Pra-Dasar & Dasar",
    ageRange: "5-7",
    descriptionEn: "Building foundation in ballet technique. Students learn basic positions, simple choreography, and classroom etiquette.",
    descriptionId: "Membangun fondasi teknik balet. Siswa belajar posisi dasar, koreografi sederhana, dan etika kelas.",
    image: "/images/preprimary.jpeg"
  },
  {
    id: 3,
    titleEn: "Grade 1 - 2",
    titleId: "Kelas 1 - 2",
    ageRange: "8-10",
    descriptionEn: "Advanced preparation for formal ballet training. Focus on proper technique, coordination, and performance skills.",
    descriptionId: "Persiapan lanjutan untuk pelatihan balet formal. Fokus pada teknik yang benar, koordinasi, dan keterampilan pertunjukan.",
    image: "/images/grade1.jpeg"
  }
];

export const benefits = [
  {
    titleEn: "Physical Development",
    titleId: "Perkembangan Fisik",
    descriptionEn: "Improves flexibility, coordination, and motor skills",
    descriptionId: "Meningkatkan fleksibilitas, koordinasi, dan keterampilan motorik",
    icon: "heart"
  },
  {
    titleEn: "Discipline & Focus",
    titleId: "Disiplin & Fokus",
    descriptionEn: "Builds concentration and self-discipline",
    descriptionId: "Membangun konsentrasi dan disiplin diri",
    icon: "star"
  },
  {
    titleEn: "Creative Expression",
    titleId: "Ekspresi Kreatif",
    descriptionEn: "Encourages artistic expression and imagination",
    descriptionId: "Mendorong ekspresi artistik dan imajinasi",
    icon: "sparkles"
  },
  {
    titleEn: "Confidence Building",
    titleId: "Membangun Kepercayaan Diri",
    descriptionEn: "Develops self-confidence through performance",
    descriptionId: "Mengembangkan kepercayaan diri melalui pertunjukan",
    icon: "trophy"
  },
  {
    titleEn: "Social Skills",
    titleId: "Keterampilan Sosial",
    descriptionEn: "Learn teamwork and make new friends",
    descriptionId: "Belajar kerja tim dan mendapat teman baru",
    icon: "users"
  },
  {
    titleEn: "Musical Awareness",
    titleId: "Kesadaran Musik",
    descriptionEn: "Develops rhythm and musical appreciation",
    descriptionId: "Mengembangkan ritme dan apresiasi musik",
    icon: "music"
  }
];

export const testimonials = [
  {
    id: 1,
    nameEn: "Sarah's Mother",
    nameId: "Ibu Sarah",
    textEn: "My daughter has transformed so much since joining Studio Ballet Izora. Ditamaya is incredibly patient and makes every child feel special.",
    textId: "Anak saya sangat berubah sejak bergabung dengan Studio Ballet Izora. Ditamaya sangat sabar dan membuat setiap anak merasa istimewa."
  },
  {
    id: 2,
    nameEn: "Ayu's Parent",
    nameId: "Orang Tua Ayu",
    textEn: "The best ballet school in Surabaya! Professional teaching methods and a nurturing environment for young children.",
    textId: "Sekolah balet terbaik di Surabaya! Metode pengajaran profesional dan lingkungan yang memelihara untuk anak-anak."
  },
  {
    id: 3,
    nameEn: "Rina's Father",
    nameId: "Ayah Rina",
    textEn: "We are so happy with our daughter's progress. She has become more confident and loves going to her ballet classes.",
    textId: "Kami sangat senang dengan kemajuan anak kami. Dia menjadi lebih percaya diri dan senang pergi ke kelas baletnya."
  }
];

export const images = {
  hero: "/images/hero.png",
  about: "/images/about.png",
  classes: "https://images.pexels.com/photos/6718538/pexels-photo-6718538.jpeg?auto=compress&cs=tinysrgb&w=600",
  instructor: "/images/instructor.png",
  testimonials: "https://images.unsplash.com/photo-1595033950840-84340c803643?w=800"
};

// Gallery Images for Graduation 2026 at Pala Ballroom Suite Hotel Surabaya
export const galleryImages = [
  "/images/gallery/grad1.jpg",
  "/images/gallery/grad2.jpg",
  "/images/gallery/grad3.jpg",
  "/images/gallery/grad4.jpg",
  "/images/gallery/grad5.jpg",
  "/images/gallery/grad6.jpg",
  "/images/gallery/grad7.jpg",
  "/images/gallery/grad8.jpg",
  "/images/gallery/grad9.jpg",
  "/images/gallery/grad10.jpg",
  "/images/gallery/grad11.jpg",
  "/images/gallery/grad12.jpg",
  "/images/gallery/grad13.jpg",
  "/images/gallery/grad14.jpg",
  "/images/gallery/grad15.jpg",
  "/images/gallery/grad16.jpg",
  "/images/gallery/grad17.jpg",
  "/images/gallery/grad18.jpg",
  "/images/gallery/grad19.jpg",
  "/images/gallery/grad20.jpg",
  "/images/gallery/grad21.jpg",
  "/images/gallery/grad22.jpg",
  "/images/gallery/grad23.jpg",
  "/images/gallery/grad24.jpg",
  "/images/gallery/grad25.jpg",
  "/images/gallery/grad26.jpg",
  "/images/gallery/grad27.jpg",
  "/images/gallery/grad28.jpg",
  "/images/gallery/grad29.jpg",
  "/images/gallery/grad30.jpg",
  "/images/gallery/grad31.jpg",
  "/images/gallery/grad32.jpg",
  "/images/gallery/grad33.jpg",
  "/images/gallery/grad34.jpg",
  "/images/gallery/grad35.jpg",
  "/images/gallery/grad36.jpg",
  "/images/gallery/grad37.jpg",
  "/images/gallery/grad38.jpg",
  "/images/gallery/grad39.jpg",
  "/images/gallery/grad40.jpg",
  "/images/gallery/grad41.jpg",
  "/images/gallery/grad42.jpg",
  "/images/gallery/grad43.jpg",
  "/images/gallery/grad44.jpg",
  "/images/gallery/grad45.jpg",
  "/images/gallery/grad46.jpg",
  "/images/gallery/grad47.jpg",
  "/images/gallery/grad48.jpg",
  "/images/gallery/grad49.jpg",
  "/images/gallery/grad50.jpg",
  "/images/gallery/grad51.jpg",
  "/images/gallery/grad52.jpg",
  "/images/gallery/grad53.jpg",
  "/images/gallery/grad54.jpg",
  "/images/gallery/grad55.jpg",
  "/images/gallery/grad56.jpg",
  "/images/gallery/grad57.jpg",
  "/images/gallery/grad58.jpg",
  "/images/gallery/grad59.jpg",
  "/images/gallery/grad60.jpg",
  "/images/gallery/grad61.jpg",
  "/images/gallery/grad62.jpg",
  "/images/gallery/grad63.jpg",
  "/images/gallery/grad64.jpg",
  "/images/gallery/grad65.jpg",
  "/images/gallery/grad66.jpg",
  "/images/gallery/grad67.jpg",
  "/images/gallery/grad68.jpg",
  "/images/gallery/grad69.jpg",
  "/images/gallery/grad70.jpg",
  "/images/gallery/grad71.jpg",
  "/images/gallery/grad72.jpg",
  "/images/gallery/grad73.jpg",
  "/images/gallery/grad74.jpg",
  "/images/gallery/grad75.jpg",
  "/images/gallery/grad76.jpg",
  "/images/gallery/grad77.jpg",
  "/images/gallery/grad78.jpg",
  "/images/gallery/grad79.jpg",
  "/images/gallery/grad80.jpg",
  "/images/gallery/grad81.jpg",
  "/images/gallery/grad82.jpg",
  "/images/gallery/grad83.jpg",
  "/images/gallery/grad84.jpg",
  "/images/gallery/grad85.jpg"
];


export const seoData = {
  titleEn: "Studio Ballet Izora | Children's Ballet School in Surabaya, Indonesia",
  titleId: "Studio Ballet Izora | Sekolah Balet Anak di Surabaya, Indonesia",
  descriptionEn: "Professional ballet training for children aged 2-10 years in Surabaya. Led by certified instructor Ditamaya. Join the best children's ballet school in East Java.",
  descriptionId: "Pelatihan balet profesional untuk anak usia 2-10 tahun di Surabaya. Dibimbing oleh instruktur bersertifikat Ditamaya. Bergabunglah dengan sekolah balet anak terbaik di Jawa Timur.",
  keywords: "ballet school Surabaya, kids ballet Indonesia, children dance class Surabaya, balet anak Surabaya, sekolah balet Indonesia, Studio Ballet Izora, Ditamaya ballet"
};
